import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as URL from '../routes';
import { MessageService, MessageServiceAdapter } from '../_models/message-service.model';

@Injectable({
  providedIn: 'root'
})
export class MessageServiceService {

  constructor(
    private http: HttpClient,
    private adapter: MessageServiceAdapter
  ) { }

  /**
   * Get all MessageService
   */
  all(): Observable<MessageService[]> {
    return this.http.get(URL.MESSAGE_SERVICES).pipe(
      map((data: any[]) => data.map(item => this.adapter.fromJson(item))), // Adapt each item in the raw data array
    );
  }


 /**
  * Delete MessageService
  */
  delete(id: number) {
    const url = URL.MESSAGE_SERVICES_ID.replace('{id}', `${id}`);
    return this.http.delete(url);
  }

}
